import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=49407c18&scoped=true&"
import script from "./WelcomeView.vue?vue&type=script&lang=ts&"
export * from "./WelcomeView.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeView.vue?vue&type=style&index=0&id=49407c18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49407c18",
  null
  
)

export default component.exports